import { useAuth } from '../Shared/Hooks/useAuth';
import PremiumErrorScreen from '../Shared/Components/PremiumErrorScreen';

const PageNotFound = () => {
  const { logout } = useAuth();
  return (
    <PremiumErrorScreen
      title="404 - Page Not Found"
      message="The page you're looking for doesn't exist or has been moved."
      onRetry={() => (window.location.href = '/')}
      onLogout={logout}
    />
  );
};

export default PageNotFound;
